import { useEffect, useRef } from "react";
import { trackEvent } from "../lib/analytics";

export default function useTrackPageView() {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) return;
    hasTrackedRef.current = true;

    const todayKey = new Date().toISOString().slice(0, 10);
    const pathname = window.location.pathname;
    const uniqueKey = `unique_page_view:${todayKey}:${pathname}`;

    const alreadyViewedToday = localStorage.getItem(uniqueKey);

    trackEvent("page_view", {
      isUniqueVisitorToday: !alreadyViewedToday,
    });

    if (!alreadyViewedToday) {
      localStorage.setItem(uniqueKey, "1");
    }

    const sessionStarted = sessionStorage.getItem("session_started");

    if (!sessionStarted) {
      trackEvent("session_start");
      sessionStorage.setItem("session_started", "1");
    }
  }, []);
}